(() => {
  if (window.dnNotificationBadgesReady) return;
  window.dnNotificationBadgesReady = true;

  const numericBadgeSelector = '.wishlist-count-badge, .cart-count-badge';

  const normalizeTextCountBadge = (badge) => {
    if (!badge) return;
    const countText = (badge.textContent || '').trim();
    const count = Number(countText);
    const hasCount = countText !== '' && countText !== '0' && (!Number.isFinite(count) || count > 0);
    badge.hidden = !hasCount;
    badge.setAttribute('aria-hidden', hasCount ? 'false' : 'true');
  };

  const normalizeThemeBadges = () => {
    document.querySelectorAll(numericBadgeSelector).forEach(normalizeTextCountBadge);
  };

  const setLoyaltyBadgeCount = (badge, count) => {
    const unreadCount = Number(count || 0);
    if (!(unreadCount > 0)) {
      badge.textContent = '';
      badge.hidden = true;
      badge.setAttribute('aria-hidden', 'true');
      badge.removeAttribute('data-count');
      return;
    }

    const displayCount = unreadCount > 9 ? '9+' : String(unreadCount);
    badge.textContent = displayCount;
    badge.dataset.count = String(unreadCount);
    badge.setAttribute('aria-hidden', 'false');
    const labelTemplate = badge.getAttribute('data-label-template') || '__COUNT__';
    badge.setAttribute('aria-label', labelTemplate.replace('__COUNT__', String(unreadCount)));
    badge.hidden = false;
  };

  const initLoyaltyBadges = () => {
    document.querySelectorAll('[data-dn-loyalty-notification-badge]').forEach(async (badge) => {
      if (badge.dataset.dnLoyaltyBadgeReady === 'true') return;
      badge.dataset.dnLoyaltyBadgeReady = 'true';
      const host = badge.closest('.mobile-bottom-nav-icon-wrap, .dn-loyalty-notification-host, a, button, summary, .nav-link');
      if (host) host.classList.add('dn-loyalty-notification-host');

      try {
        const endpoint = badge.getAttribute('data-endpoint') || '/apps/deskneko-loyalty/api/notifications';
        const response = await fetch(endpoint, {
          credentials: 'same-origin',
          headers: { accept: 'application/json' },
        });
        if (!response.ok) {
          setLoyaltyBadgeCount(badge, 0);
          return;
        }
        const data = await response.json();
        if (!data.signedIn && badge.getAttribute('data-show-signed-out') !== 'true') {
          setLoyaltyBadgeCount(badge, 0);
          return;
        }
        setLoyaltyBadgeCount(badge, data.unreadCount);
      } catch (_error) {
        setLoyaltyBadgeCount(badge, 0);
      }
    });
  };

  const initNotificationBadges = () => {
    normalizeThemeBadges();
    initLoyaltyBadges();
  };

  const badgeObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      const target = mutation.target.nodeType === Node.ELEMENT_NODE
        ? mutation.target
        : mutation.target.parentElement;
      if (!target) return;
      if (target.matches?.(numericBadgeSelector)) {
        normalizeTextCountBadge(target);
        return;
      }
      target.querySelectorAll?.(numericBadgeSelector).forEach(normalizeTextCountBadge);
    });
  });

  badgeObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
  });

  window.addEventListener('dn-loyalty-notifications-read', () => {
    document.querySelectorAll('[data-dn-loyalty-notification-badge]').forEach((badge) => {
      setLoyaltyBadgeCount(badge, 0);
    });
  });

  document.addEventListener('shopify:section:load', initNotificationBadges);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNotificationBadges, { once: true });
  } else {
    initNotificationBadges();
  }
})();
